export const LYRICS_TOOL = 'LYRICS_TOOL';
export const SECTIONS_TOOL = 'SECTIONS_TOOL';
export const PAGES_TOOL = 'PAGES_TOOL';
